import { render, staticRenderFns } from "./ShowCredentialPuntosColombia.vue?vue&type=template&id=94281b9e"
import script from "./ShowCredentialPuntosColombia.vue?vue&type=script&lang=js"
export * from "./ShowCredentialPuntosColombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94281b9e')) {
      api.createRecord('94281b9e', component.options)
    } else {
      api.reload('94281b9e', component.options)
    }
    module.hot.accept("./ShowCredentialPuntosColombia.vue?vue&type=template&id=94281b9e", function () {
      api.rerender('94281b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/LoyaltyConfig/components/ShowCredentialPuntosColombia.vue"
export default component.exports